function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "20",
  height: "16",
  viewBox: "4 -2 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M17.333 9A8.333 8.333 0 10.667 9 8.333 8.333 0 009 17.333 8.333 8.333 0 0017.333 9zm-9.166 4.167V7.678L6.256 9.59 5.077 8.411 9 4.488l3.922 3.923-1.178 1.178-1.91-1.91v5.488H8.166z",
  fill: "#fff"
})));